import './App.css';
import MasterPage from './pages/core/MasterPage';
import 'bootstrap/dist/css/bootstrap.css';

function App() {
  return (
    <MasterPage />
  );
}

export default App;
